import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generalReport } from "../redux/UserActions";
import { Redirect } from "react-router";
import Calendar from "./Calendar";
import MultiSelectListBox from "./Helper/MultiSelectListBox";
import { moodValues } from "../redux/constants";

function GeneralReport() {
  const dispatch = useDispatch();
  const [filterMoods, setFilter] = useState([]);
  const [period, setPeriod] = useState(7);
  const userSelector = useSelector((state) => state.user);

  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });

  const moods = [
    "Well",
    "Happy",
    "Excited",
    "Proud",
    "Creative",
    "Stressed",
    "Worried",
    "Sad",
    "Angry",
    "Sick",
  ];

  function handleAllChecked() {
    if (filterMoods.length === 10) {
      setFilter([]);
    } else
      setFilter([
        "Well",
        "Happy",
        "Excited",
        "Proud",
        "Creative",
        "Stressed",
        "Worried",
        "Sad",
        "Angry",
        "Sick",
      ]);
  }

  function handleCritical() {
    if (
      filterMoods.includes("Worried") &&
      filterMoods.includes("Sad") &&
      filterMoods.includes("Stressed") &&
      filterMoods.includes("Angry") &&
      filterMoods.includes("Sick")
    ) {
      setFilter(
        filterMoods.filter(
          (fl) =>
            fl !== "Worried" &&
            fl !== "Sad" &&
            fl !== "Stressed" &&
            fl !== "Angry" &&
            fl !== "Sick"
        )
      );
    } else setFilter(["Stressed", "Worried", "Sad", "Angry", "Sick"]);
  }

  function handleMoodFilter(mood) {
    if (filterMoods.includes(mood))
      setFilter(filterMoods.filter((fl) => fl !== mood));
    else setFilter([...filterMoods, mood]);
  }

  return (
    <div className="items-center w-full p-4">
      <h1 className="font-bold text-center mt-2 mb-2">Generate Mood Report</h1>
      <div className="grid grid-cols-2">
        <div className="grid grid-cols-3 w-full items-center">
          <label className="ml-2 text-gray-600 font-bold text-right pr-2">
            Select Moods:
          </label>
          <MultiSelectListBox
            listboxClasses="col-span-2 border-gray-200"
            label={"Test"}
            handleSelected={(e) => e}
            options={Object.entries(moodValues).map((key) => key[1])}
          />
          <label className="ml-2 text-gray-600 font-bold text-right pr-2">
            Select Departments:
          </label>
          <MultiSelectListBox
            listboxClasses="col-span-2 border-gray-200"
            label={"Test"}
            handleSelected={(e) => e}
            options={userSelector.organization.departments}
          />
          <label className="ml-2 text-gray-600 font-bold text-right pr-2">
            Select Locations:
          </label>
          <MultiSelectListBox
            listboxClasses="col-span-2 border-gray-200"
            label={"Test"}
            handleSelected={(e) => e}
            options={userSelector.organization.locations}
          />
        </div>
        <div className="flex flex-col justify-center items-center w-full">
          <h1 className="font-bold text-center mb-2">Period</h1>
          <Calendar
            className="w-full"
            selectedDayRange={selectedDayRange}
            setSelectedDayRange={setSelectedDayRange}
          />
        </div>
      </div>
      <button
        className="flex focus:outline-none text-white justify-center text-sm py-2.5 px-5 rounded-md bg-gray-500 hover:bg-gray-600 hover:shadow-lg mt-4 w-40 mr-auto ml-auto"
        onClick={(e) => {
          e.preventDefault();
          if (filterMoods.length > 0) {
            if (
              selectedDayRange.from === null ||
              selectedDayRange.to === null
            ) {
              alert("Select Date Range!");
            } else {
              dispatch(
                generalReport({
                  date: {
                    from: selectedDayRange.from,
                    to: selectedDayRange.to,
                  },
                  moods: filterMoods,
                })
              );
              alert(
                "Your report will be sent to your e-mail address within 3 minutes!"
              );
            }
          } else {
            alert("You haven't selected any mood!");
          }
        }}
      >
        Generate Report
      </button>
    </div>
  );
}

export default GeneralReport;
